import { logEvent } from 'firebase/analytics';
import messages from 'aurora-translations';
import ClevertapReact from './CleverTap';
import filter from './filters.json';
import { applicationTypes } from './constants';
import { analytics } from '../containers/App';
import { convertStringToDate, convertNumberFormat } from './utils';

export const CleverTapEvent = (eventName, payload) => {
  // ClevertapReact.event(eventName, payload || {});
  // logEvent(analytics, eventName, payload);
};

// Home Screen
export const CleverTapHomeScreen = () => {
  CleverTapEvent('screen_home_view');
};
export const CleverTapProfileUpdate = userRes => {
  const params = {
    Site: {
      Name: userRes?.customerNameEn || userRes?.firstNameEn,
      Identity: userRes?.userId,
      Email: userRes?.emailAddress,
      Phone_Nummber: userRes?.mobileNumber,
      Gender: userRes?.gender === 'MALE' ? 'M' : 'F',
      DOB: userRes?.birthDate && new Date(userRes?.birthDate),
      'MSG-email': true,
      'MSG-push': true,
      'MSG-sms': true,
      'MSG-whatsapp': true,
      Role: 'Personal Account',
      Nationality: userRes?.nationalityEn,
      Is_super_admin: false,
      Name_ar: userRes?.customerNameAr || userRes?.firstNameAr,
      is_owner: userRes?.isOwner,
      is_tenant: userRes?.isTenant,
      is_pma_representative: userRes?.isPma,
      is_poa_representative: userRes?.isPoa,
      is_bank: userRes?.isBank,
      language: localStorage.getItem('lang')?.toUpperCase(),
      user_plateform: 'WEB',
      isNonResident: !userRes?.isNational,
    },
  };
  // ClevertapReact.profile(params || {});
};
// Application
export const CleverTapApplicationScreen = () => {
  CleverTapEvent('screen_applications_view');
};
export const CleverTapDirectoryProjects = payload => {
  CleverTapEvent('directory_projects_filters', payload);
};
export const CleverTapDirectoryProfessions = payload => {
  CleverTapEvent('directory_professions_filters', payload);
};
export const CleverTapDirectoryProjectDetail = payload => {
  CleverTapEvent('directory_projects_detailpage', payload);
};
export const CleverTapDirectoryProfessionDetail = payload => {
  CleverTapEvent('directory_professions_detailpage', payload);
};
export const CleverTapLeaseContractsFlow = () => {
  CleverTapEvent('lease_contracts');
};
export const CleverTapPOAContractsFlow = () => {
  CleverTapEvent('poa_contracts');
};

export const CleverTapContractsFlowFilter = payload => {
  payload.type === 'Lease' && CleverTapEvent('lease_contract_filter', payload);
  payload.type === 'Pma' && CleverTapEvent('pma_contract_filter', payload);
  // else CleverTapEvent('poa_contract_filter', payload);
};
export const CleverTapContractsDetail = payload => {
  CleverTapEvent('lease_contract_detailpage', payload);
};
export const CleverTapPropertiesFlow = payload => {
  if (payload === 'ownership') CleverTapEvent('properties_ownership');
  else CleverTapEvent('properties_lease');
};

export const CleverTapPropertiesFilter = payload => {
  /* eslint no-restricted-globals: ["error", "event", "fdescribe"] */
  const locale = location.pathname.split('/')[1];
  const municipality = filter.municipality.find(item => item.value === payload.municipality);
  let municipalityName = '';
  if (municipality) {
    if (locale === 'en') municipalityName = municipality.labelEn;
    else municipalityName = municipality.labelAr;
  }
  const district = filter.district.find(item => item.value === payload.district);
  let districtName = '';
  if (district) {
    if (locale === 'en') districtName = district.labelEn;
    else districtName = district.labelAr;
  }
  const community = filter?.community.find(item => item.value === payload.community);
  let communityName = '';
  if (community) {
    if (locale === 'ar') communityName = community.labelAr;
    else communityName = community.labelEn;
  }

  if (payload.type === 'lease')
    CleverTapEvent('properties_lease_filters', {
      municipality: municipalityName,
      community: communityName,
      district: districtName,
      rentStatus: payload.rentStatus,
      bedrooms: payload.bedrooms,
      propertyRegNo: payload.propertyRegNo,
      unitRegNo: payload.unitRegNo,
      plotNumber: payload.plotNumber,
      buildingId: payload.buildingNumber,
      unitNumber: payload.unitNumber,
      tenantOnly: payload.tenantOnly,
      poaOnly: payload.poaOnly,
      propertyType: payload.propertyType,
    });
  else if (payload.type === 'mortgage')
    CleverTapEvent('properties_mortgage_filter', {
      municipality: municipalityName,
      district: districtName,
      community: communityName,
      plotNumber: payload.plotNumber,
      projectStatus: payload.projectStatus,
      allocationType: payload.allocationType,
      isBlocked: payload.isBlocked,
      noOfRoom: payload.noOfRoom,
      mortgageType: payload.mortgageType,
    });
  else
    CleverTapEvent('properties_ownership_filter', {
      plotNumber: payload.plotNumber,
      municipality: municipalityName,
      municipalityID: payload.municipality,
      districtID: payload.district,
      communityID: payload.community,
      community: communityName,
      district: districtName,
      // allocationType: payload.allocationType,
      plotAllocationTypeID: payload.allocationType,
      // ownerShipType: payload.ownerShipTypeID,
      ownerShipTypeID: payload.ownerShipTypeID,
      isMortgaged: payload.isMortgaged,
      noOfRoom: payload.noOfRoom,
      isBlocked: payload.isBlocked,
      propertyType: payload.propertyType,
      // acquisitionType: payload.acquisitionTypeId,
      acquisitionTypeId: payload.acquisitionTypeId,
      ownershipPoaProperty: payload.ownershipPoaProperty,
      poaCustomerIds: convertNumberFormat(payload.poaCustomerIds),
      projectStatus: payload.projectStatus,
    });
};
export const CleverTapPropertiesFilterSeeMore = payload => {
  /* eslint no-restricted-globals: ["error", "event", "fdescribe"] */
  const type = new URLSearchParams(location.search).get('type');
  if (type === 'lease') {
    if (payload) CleverTapEvent('properties_lease_all_filters');
    else CleverTapEvent('properties_lease_less_filters');
  }
  if (type === 'ownership') {
    if (payload) CleverTapEvent('properties_ownership_all_filters');
    else CleverTapEvent('properties_ownership_less_filters');
  }
};
export const CleverTapPropertiesDetail = payload => {
  CleverTapEvent('property_detailspage', payload);
};
export const CleverTapProfileMyProfile = payload => {
  CleverTapEvent('screen_view', { screenName: 'screen_my_profile_view', ...payload });
};

export const CleverTapProfileWallet = () => {
  CleverTapEvent('profile_wallet');
};
export const CleverTapProfileLanguage = lang => {
  CleverTapEvent('switch_language', { language: lang });
};
export const CleverTapProfileHelp = () => {
  CleverTapEvent('profile_help');
};
export const CleverTapProfileTermsConditions = () => {
  CleverTapEvent('profile_terms');
};
export const CleverTapProfileLogout = () => {
  CleverTapEvent('profile_logout');
};
export const CleverTapWalletTopUp = payload => {
  CleverTapEvent('wallet_topup', { amount: payload });
};
// wallet remaining events?????

export const CleverTapTransactionFilters = payload => {
  CleverTapEvent('transaction_filters', payload);
};
export const CleverTapServicesMainService = payload => {
  CleverTapEvent(`click_main_service`, payload);
};
export const CleverTapServicesSubService = payload => {
  CleverTapEvent(`click_sub_service`, payload);
};
export const CleverTapServicesStartApplication = payload => {
  CleverTapEvent(`click_start_application`, payload);
};
export const CleverTapServicesPreValidation = payload => {
  CleverTapEvent('initiate_service_prevalidation', payload);
};
export const CleverTapServicesLeaseFlow = () => {
  CleverTapEvent('services_lease');
};
export const CleverTapServicesLeaseRegistrationInitiateFlow = () => {
  CleverTapEvent('services_lease-registration_initiate_post_validation');
};
export const CleverTapServicesLeaseCancellationInitiateFlow = () => {
  CleverTapEvent('services_lease-cancellation_initiate');
};
export const CleverTapServicesLeaseAmendmentInitiateFlow = () => {
  CleverTapEvent('services_lease-amendment_initiate');
};
export const CleverTapServicesLeaseRenewalInitiateFlow = () => {
  CleverTapEvent('services_lease-renewal_initiate');
};
export const CleverTapServicesLeaseClosureInitiateFlow = () => {
  CleverTapEvent('services_lease_close_initiate');
};
// /////
export const CleverTapServicesCertificateFlow = () => {
  CleverTapEvent('services_certificates');
};

export const CleverTapServicesCertificateUnitTitleDeedInitiateFlow = () => {
  CleverTapEvent('services_certificates_unit_titledeed_initiate');
};
export const CleverTapServicesCertificateLandTitleDeedInitiateFlow = () => {
  CleverTapEvent('services_certificates_land_titledeed_initiate');
};
export const CleverTapServicesCertificateOwnedPropertiesInitiateFlow = () => {
  CleverTapEvent('services_certificates_ownedproperties_initiate');
};
export const CleverTapServicesCertificateUnitVerificationInitiateFlow = () => {
  CleverTapEvent('services_certificates_unit_verification_initiate');
};
export const CleverTapServicesCertificateLandVerificationInitiateFlow = () => {
  CleverTapEvent('services_certificates_land_verfication_initiate');
};
export const CleverTapServicesCertificateSitePlanInitiateFlow = () => {
  CleverTapEvent('services_certificates_siteplan_initiate');
};
export const CleverTapServicesCertificateInitiateEvent = payload => {
  switch (payload) {
    case applicationTypes.CERT_TITLE_DEED_UNIT:
      CleverTapServicesCertificateUnitTitleDeedInitiateFlow();
      break;
    case applicationTypes.CERT_TITLE_DEED_PLOT:
      CleverTapServicesCertificateLandTitleDeedInitiateFlow();
      break;
    case applicationTypes.CERT_SITE_PLAN_PLOT:
    case applicationTypes.CERT_SITE_PLAN_UNIT:
      CleverTapServicesCertificateSitePlanInitiateFlow();
      break;

    case applicationTypes.CERT_VERIFICATION_PLOT:
      CleverTapServicesCertificateLandVerificationInitiateFlow();
      break;
    case applicationTypes.CERT_VERIFICATION_UNIT:
      CleverTapServicesCertificateUnitVerificationInitiateFlow();
      break;
    case applicationTypes.CERT_PROP_OWNERSHIP:
      CleverTapServicesCertificateOwnedPropertiesInitiateFlow();
      break;
    default:
  }
};
export const CleverTapServicesCertificateUnitTitleDeedPropertySelection = propertyId => {
  CleverTapEvent('unit_titledeed_select_property', { property_id: propertyId });
};
export const CleverTapServicesCertificateLandTitleDeedPropertySelection = propertyId => {
  CleverTapEvent('land_titledeed_select_property', { property_id: propertyId });
};
export const CleverTapServicesCertificateLanSitePlanPropertySelection = propertyId => {
  CleverTapEvent('land_siteplan_select_property', { property_id: propertyId });
};
export const CleverTapServicesCertificatePropertySelection = payload => {
  switch (payload.pathname) {
    case '/app/services/issue-title-deed-unit':
      CleverTapServicesCertificateUnitTitleDeedPropertySelection(payload.plotId);
      break;
    case '/app/services/issue-title-deed-land':
      CleverTapServicesCertificateLandTitleDeedPropertySelection(payload.plotId);
      break;
    case '/app/services/issue-verification-certificate-unit':
    case '/app/services/issue-verification-certificate-land':
      break;
    case '/app/services/issue-site-plan-land':
      CleverTapServicesCertificateLanSitePlanPropertySelection(payload.plotId);
      break;
    default:
  }
};
export const CleverTapServicesCertificateUnitTitleDeedSubmit = payload => {
  CleverTapEvent('unit_titledeed_submit', payload);
};
export const CleverTapServicesCertificateUnitTitleDeedSuccess = payload => {
  CleverTapEvent('unit_titledeed_success', payload);
};
export const CleverTapServicesCertificateUnitTitleDeedSuccessDownload = payload => {
  CleverTapEvent('certificate_success_download', payload);
};

export const CleverTapServicesCertificateLandTitleDeedSubmit = payload => {
  CleverTapEvent('land_titledeed_submit', payload);
};
export const CleverTapServicesCertificateLandTitleDeedSuccess = payload => {
  CleverTapEvent('land_titledeed_success', payload);
};
export const CleverTapServicesCertificateLandTitleDeedSuccessDownload = payload => {
  CleverTapEvent('certificate_success_download', payload);
};

export const CleverTapServicesCertificatePropertyOwnerShipSubmit = payload => {
  CleverTapEvent('ownedproperties_submit', payload);
};
export const CleverTapServicesCertificatePropertyOwnerShipSuccess = payload => {
  CleverTapEvent('ownedproperties_success', payload);
};
export const CleverTapServicesCertificatePropertyOwnerShipSuccessDownload = payload => {
  CleverTapEvent('certificate_success_download', payload);
};

export const CleverTapServicesCertificateLandSitePlanSubmit = payload => {
  CleverTapEvent('land_siteplan_submit', payload);
};
export const CleverTapServicesCertificateLandSitePlanSuccess = payload => {
  CleverTapEvent('land_siteplan_success', payload);
};
export const CleverTapServicesCertificateLandSitePlanSuccessDownload = payload => {
  CleverTapEvent('certificate_success_download', payload);
};
export const CleverTapServicesCertificateSubmit = (payload, type) => {
  switch (type) {
    case applicationTypes.CERT_TITLE_DEED_UNIT:
      CleverTapServicesCertificateUnitTitleDeedSubmit(payload);
      break;
    case applicationTypes.CERT_TITLE_DEED_PLOT:
      CleverTapServicesCertificateLandTitleDeedSubmit(payload);
      break;
    case applicationTypes.CERT_PROP_OWNERSHIP:
      CleverTapServicesCertificatePropertyOwnerShipSubmit(payload);
      break;
    case applicationTypes.CERT_SITE_PLAN_PLOT:
      CleverTapServicesCertificateLandSitePlanSubmit(payload);
      break;
    default:
  }
};
export const CleverTapServicesCertificateSuccess = (payload, type) => {
  switch (type) {
    case applicationTypes.CERT_TITLE_DEED_UNIT:
      CleverTapServicesCertificateUnitTitleDeedSuccess(payload);
      break;
    case applicationTypes.CERT_TITLE_DEED_PLOT:
      CleverTapServicesCertificateLandTitleDeedSuccess(payload);
      break;
    case applicationTypes.CERT_PROP_OWNERSHIP:
      CleverTapServicesCertificatePropertyOwnerShipSuccess(payload);
      break;
    case applicationTypes.CERT_SITE_PLAN_PLOT:
      CleverTapServicesCertificateLandSitePlanSuccess(payload);
      break;
    default:
  }
};
export const CleverTapServicesCertificateDownload = (payload, type) => {
  switch (type) {
    case applicationTypes.CERT_TITLE_DEED_UNIT:
      CleverTapServicesCertificateUnitTitleDeedSuccessDownload(payload);
      break;
    case applicationTypes.CERT_TITLE_DEED_PLOT:
      CleverTapServicesCertificateLandTitleDeedSuccessDownload(payload);
      break;
    case applicationTypes.CERT_PROP_OWNERSHIP:
      CleverTapServicesCertificatePropertyOwnerShipSuccessDownload(payload);
      break;
    case applicationTypes.CERT_SITE_PLAN_PLOT:
      CleverTapServicesCertificateLandSitePlanSuccessDownload(payload);
      break;
    default:
  }
};

//
export const CleverTapServicesAuthorizationFlow = () => {
  CleverTapEvent('services_authorizations');
};
export const CleverTapServicesAuthorizationInitiateFlow = () => {
  CleverTapEvent('services_authorization_poa_initiate');
};
export const CleverTapServicesCompanyFlow = () => {
  CleverTapEvent('services_company_management');
};
export const CleverTapServicesCompanyInitiateFlow = () => {
  CleverTapEvent('services_company_management_register_initiate');
};
export const CleverTapServicesSaleFlow = () => {
  CleverTapEvent('services_sale');
};
export const CleverTapServicesSaleInitiateFlow = () => {
  CleverTapEvent('services_sell_property_initiate');
};
export const CleverTapNavigation = navigationName => {
  switch (navigationName) {
    case 'home':
      CleverTapEvent('navigation_tab_home');
      break;
    case 'applications':
      CleverTapEvent('navigation_tab_applications');
      break;
    case 'services':
      CleverTapEvent('navigation_tab_services');
      break;
    case 'properties':
      CleverTapEvent('navigation_tab_properties');
      break;
    case 'directory':
      CleverTapEvent('navigation_tab_directory (web only)');
      break;
    case 'market-data-detail':
      CleverTapEvent('navigation_tab_market_data (web only)');
      break;
    case 'contracts':
      CleverTapEvent('navigation_tab_contracts');
      break;
    default:
  }
};
export const CleverTapHomePageSeeALL = sectionId => {
  // CleverTapEvent('service_icons', { name: serviceName });
  switch (sectionId) {
    case 'ownedproperties':
      // owned properties
      CleverTapEvent('home_ownedproperties_see_all');
      break;
    case 'projects':
      // Real State projects
      CleverTapEvent('home_projects_see_all');
      break;
    case 'brokers':
      // Registered brokers
      CleverTapEvent('home_brokers_see_all');
      break;
    case 'surveyors':
      // Registered surveyors
      CleverTapEvent('home_surveyors_see_all');
      break;
    case 'directories':
      // Directories
      CleverTapEvent('home_directories_see_all');
      break;
    case 'marketdata':
      // Transactions in Abu Dhabi Emirate
      CleverTapEvent('home_marketdata_see_all');
      break;
    default:
  }
};
export const CleverTapHomePageService = serviceName => {
  switch (serviceName) {
    case 'lease':
      CleverTapEvent('home_services_lease');
      break;
    case 'certificates':
      CleverTapEvent('home_services_certificates');
      break;
    case 'company-management':
      CleverTapEvent('home_services_company_management');
      break;
    case 'sale':
      CleverTapEvent('home_services_sale');
      break;
    case 'authorizations':
      CleverTapEvent('home_services_authorizations');
      break;
    case 'directories':
      CleverTapEvent(serviceName);
      break;
    default:
  }
};
export const CleverTapHomePageTasksSeeAll = () => {
  CleverTapEvent('home_tasks_check_all');
};
export const CleverTapApplicationTasks = () => {
  CleverTapEvent('applications_tasks');
};
export const CleverTapApplicationTasksDetailPage = id => {
  CleverTapEvent('applications_task_detail_page', { task_id: id });
};
export const CleverTapVerifyTenancyContract = contractNumber => {
  if (!contractNumber) CleverTapEvent('verify_tenancy_contract');
  else CleverTapEvent('verify_tenancy_contract_verify', { contract_number: contractNumber });
};
export const CleverTapHeaderLanguageSwitch = lang => {
  CleverTapEvent('switch_language', { language: lang });
};
export const CleverTapHeaderHelp = () => {
  CleverTapEvent('header_help');
};
export const CleverTapFooterLanguageSwitch = lang => {
  CleverTapEvent('switch_language', { language: lang });
};

export const CleverTapMarketDataPriceIndices = () => {
  CleverTapEvent('market_data_priceindices');
};
export const CleverTapMarketDataAveragePrices = () => {
  CleverTapEvent('market_data_averageprices');
};
export const CleverTapMarketDataAveragePricesSale = () => {
  CleverTapEvent('market_data_averageprices_sale');
};
export const CleverTapMarketDataAveragePricesRent = () => {
  CleverTapEvent('market_data_averageprices_rent');
};
export const CleverTapMarketDataTransaction = () => {
  CleverTapEvent('market_data_transactions');
};
export const CleverTapMarketDataTransactionSale = () => {
  CleverTapEvent('market_data_transactions_sale');
};
export const CleverTapMarketDataTransactionMortgage = () => {
  CleverTapEvent('market_data_transactions_mortgage');
};
/**
 * this is screen event for each step against all services
 * @param {
 * screenName : screen_{applicationType}_{stepName}_view,
 * applicationStatus,
 * applicationId,
 * applicationNumber,
 * applicationType,
 * }
 */
export const CleverTapGenericServiceScreenEvent = payload => {
  CleverTapEvent('screen_view', payload);
};

// certficates

// Certificate download Screen
export const CleverTapCertifcateDownloadScreen = (name, payload) => {
  CleverTapEvent(name, payload);
};

export const CleverTapDownload = (name, payload) => {
  CleverTapEvent(name, payload);
};

export const CleverTapGenericServiceNextEvent = payload => {
  const formatPayload = {
    ...payload,
    ...(payload?.passportIssueDate && { passportIssueDate: convertStringToDate(payload?.passportIssueDate) }),
    ...(payload?.passportExpiryDate && { passportExpiryDate: convertStringToDate(payload?.passportExpiryDate) }),
    ...(payload?.birthDate && { birthDate: convertStringToDate(payload?.birthDate) }),
    ...(payload?.contractDetails && {
      contractDetails: {
        ...payload?.contractDetails,
        dateOfSale: convertStringToDate(payload?.contractDetails?.dateOfSale),
        projectCompletionDate: convertStringToDate(payload?.contractDetails?.projectCompletionDate),
      },
    }),
  };
  CleverTapEvent(`application_step_click_next`, formatPayload);
};

export const CleverTapGenericServiceNextSuccessEvent = payload => {
  CleverTapEvent(`application_step_next_success`, payload);
};

export const CleverTapGenericServiceNextFailureEvent = payload => {
  CleverTapEvent(`application_step_next_failure`, payload);
};

/**
 *
 * @param {
 * screenName : screen_{applicationType}_{stepName}_view,
 * applicationStatus,
 * applicationId,
 * applicationNumber,
 * applicationType,
 * documentType,
 * documentIndex
 * }
 */
export const CleverTapGenericServiceUploadDocumentEvent = payload => {
  CleverTapEvent(`application_uploadDocument`, payload);
};
/**
 *
 * @param {
 * screenName : screen_{applicationType}_{stepName}_view,
 * applicationStatus,
 * applicationId,
 * applicationNumber,
 * applicationType,
 * }
 */
export const CleverTapTaskReviewApplicationCancelEvent = payload => {
  CleverTapEvent(`click_application_cancel`, payload);
};
export const CleverTapTaskReviewApplicationInItCloseEvent = payload => {
  CleverTapEvent(`click_application_init_close`, payload);
};

export const CleverTapTaskReviewApplicationResubmitEvent = payload => {
  CleverTapEvent(`click_application_resubmit`, payload);
};
export const CleverTapGenericServiceSubmitEvent = payload => {
  CleverTapEvent(`application_click_submit`, payload);
};
/**
 *
 * @param {
 * screenName : screen_{applicationType}_{stepName}_view,
 * applicationStatus,
 * applicationId,
 * applicationNumber,
 * applicationType,
 * }
 */
export const CleverTapGenericServiceSubmitSuccessEvent = payload => {
  CleverTapEvent(`application_submit_success`, payload);
};
/**
 *
 * @param {
 * screenName : screen_{applicationType}_{stepName}_view,
 * applicationStatus,
 * applicationId,
 * applicationNumber,
 * applicationType,
 * } + errorCode+ errorMessage
 */
export const CleverTapGenericServiceSubmitFailureEvent = payload => {
  CleverTapEvent(`application_submit_failure`, payload);
};
/**
 *
 * @param {
 * screenName : screen_{applicationType}_{stepName}_view,
 * applicationStatus,
 * applicationId,
 * applicationNumber,
 * applicationType,
 * }
 */
export const CleverTapGenericServiceSubmitSuccessScreenEvent = payload => {
  CleverTapEvent(`screen_view`, payload);
};
/**
 *
 * @param {
 * screenName : screen_{applicationType}_{stepName}_view,
 * applicationStatus,
 * applicationId,
 * applicationNumber,
 * applicationType,
 * }
 */
export const CleverTapGenericServiceAddOccupantEvent = payload => {
  CleverTapEvent(`application_addOccupant`, payload);
};
/**
 *
 * @param {
 * applicationType
 * propertyId,
 * }
 */

export const CleverTapGenericServiceSelectPropertyEvent = payload => {
  CleverTapEvent(`click_select_property`, {
    propertyId: payload?.propertyId,
    applicationType: payload?.applicationType,
  });
};

// Application details
export const CleverTapApplicationDetails = payload => {
  CleverTapEvent('screen_view', {
    screenName: `screen_application_details_view`,
    applicationStatus: payload?.applicationStatus,
    applicationId: payload?.applicationId,
    applicationNumber: payload?.applicationNumber,
    applicationType: payload?.applicationType,
    contractNumber: payload?.contractNumber,
    contractStartDate: convertStringToDate(payload?.contractStartDate),
    contractEndDate: convertStringToDate(payload?.contractEndDate),
    initiatorName: payload?.initiatorName,
    initiatorNameAr: payload?.initiatorNameAr,
    plotId: payload?.plotId,
  });
};

// Cancel Application details
export const CleverTapCancelApplicationDetails = payload => {
  CleverTapEvent('application_details_cancel_application', {
    applicationStatus: payload?.applicationStatus,
    applicationId: payload?.applicationId,
    applicationNumber: payload?.applicationNumber,
    applicationType: payload?.applicationType,
    contractNumber: payload?.contractNumber,
    contractStartDate: convertStringToDate(payload?.contractStartDate),
    contractEndDate: convertStringToDate(payload?.contractEndDate),
  });
};

// Cancel Application details Success
export const CleverTapCancelApplicationDetailsSuccess = payload => {
  CleverTapEvent('application_details_cancel_application_success', {
    applicationStatus: payload?.applicationStatus,
    applicationId: payload?.applicationId,
    applicationNumber: payload?.applicationNumber,
    applicationType: payload?.applicationType,
    contractNumber: payload?.contractNumber,
    contractStartDate: convertStringToDate(payload?.contractStartDate),
    contractEndDate: convertStringToDate(payload?.contractEndDate),
  });
};

// Cancel Application details Failure
export const CleverTapCancelApplicationDetailsFailure = payload => {
  CleverTapEvent('application_details_cancel_application_failure', {
    applicationStatus: payload?.applicationStatus,
    applicationId: payload?.applicationId,
    applicationNumber: payload?.applicationNumber,
    applicationType: payload?.applicationType,
    contractNumber: payload?.contractNumber,
    contractStartDate: convertStringToDate(payload?.contractStartDate),
    contractEndDate: convertStringToDate(payload?.contractEndDate),
    errorCode: payload?.errorCode,
    errorMessage: payload?.errorMessage,
  });
};

// Validate Premise
export const CleverTapValidatePremise = payload => {
  CleverTapEvent(`validate_premise`, {
    applicationStatus: payload?.applicationStatus,
    applicationId: payload?.applicationId,
    applicationNumber: payload?.applicationNumber,
    applicationType: payload?.applicationType,
    premiseId: payload?.premiseId,
    stepName: 'PROPERTY_DETAILS',
    screenName: `screen_${payload?.applicationType}_PROPERTY_DETAILS_view`,
    isSuccess: payload?.isSuccess,
    errorMessage: messages[payload?.errorMessage]?.defaultmessages || '',
    errorCode: payload?.errorCode,
  });
};

// Fetch Tenant
export const CleverTapFetchTenant = payload => {
  CleverTapEvent(`fetch_tenant`, {
    applicationStatus: payload?.applicationStatus,
    applicationId: payload?.applicationId,
    applicationNumber: payload?.applicationNumber,
    applicationType: payload?.applicationType,
    stepName: 'TENANT_DETAILS',
    screenName: `screen_${payload?.applicationType}_TENANT_DETAILS_view`,
    tenantID: payload?.tenantID,
    isSuccess: payload?.isSuccess,
    errorMessage: messages[payload?.errorMessage]?.defaultmessages || '',
    errorCode: payload?.errorCode,
  });
};

// Fetch Tenant
export const CleverTapAddAppendix = payload => {
  CleverTapEvent(`application_addAppendix`, {
    applicationStatus: payload?.applicationStatus,
    applicationId: payload?.applicationId,
    applicationNumber: payload?.applicationNumber,
    applicationType: payload?.applicationType,
    appendixIndex: payload?.appendixIndex,
    stepName: 'APPENDIX_AND_DOCUMENTS',
  });
};

// Application Task
export const CleverTapApplicationTaskScreen = () => {
  CleverTapEvent('screen_tasks_view');
};

// Services View
export const CleverTapScreenServices = () => {
  CleverTapEvent('screen_services_view');
};

// Properties Ownership
export const CleverTapScreenPropertiesOwnership = () => {
  CleverTapEvent('screen_properties_ownership_view');
};

// Properties Lease
export const CleverTapScreenPropertiesLease = () => {
  CleverTapEvent('screen_properties_lease_view');
};

// Contarcts Lease
export const CleverTapScreenContarctsLease = () => {
  CleverTapEvent('screen_view', { screenName: 'screen_contracts_lease_view' });
};

// Contarcts Pma
export const CleverTapScreenContarctsPma = () => {
  CleverTapEvent('screen_view', { screenName: 'screen_contracts_pma_view' });
};

// Contarcts Pma details
export const CleverTapContarctPmaDetails = payload => {
  CleverTapEvent('screen_pma_contract_details_view', payload);
};

// Contarcts Lease details
export const CleverTapContarctLeaseDetails = payload => {
  CleverTapEvent('screen_lease_contract_details_view', payload);
};

// Property Details
export const CleverTapPropertyDetails = payload => {
  CleverTapEvent('screen_property_details_view', payload);
};

// Task Details
// export const CleverTapTaskDetails = (payload) => {
//   CleverTapEvent('screen_task_details_view', payload);
// };

// Projects View
export const CleverTapProjectsScreenView = payload => {
  CleverTapEvent('screen_view', payload);
};

// Professions View
export const CleverTapProfessionsScreenView = payload => {
  CleverTapEvent('screen_view', payload);
};

// Project Details View
export const CleverTapProjectDetailsView = payload => {
  CleverTapEvent('screen_project_details_view', payload);
};

// Profession Details View
export const CleverTapProfessionDetailsView = payload => {
  CleverTapEvent('screen_profession_details_view', payload);
};

// Empolyee Details View
export const CleverTapEmpolyeeDetailsView = payload => {
  CleverTapEvent('screen_empolyee_details_view', payload);
};

// Payment

// PaymentDetails
export const CleverTapPaymentScreenViewEvent = payload => {
  CleverTapEvent('screen_view', { screenName: 'screen_payment_details_view', ...payload });
};

export const CleverTapPaymentScreenSubmitEvent = payload => {
  CleverTapEvent('click_pay', payload);
};
export const CleverTapPaymentScreenSuccessEvent = payload => {
  CleverTapEvent('charged', payload);
};
export const CleverTapPaymentScreenFailureEvent = payload => {
  CleverTapEvent('payment_failure', payload);
};
export const CleverTapPaymentScreenTypeCardEvent = payload => {
  CleverTapEvent('screen_view', payload);
};
export const CleverTapPaymentScreenCancelApplicationEvent = payload => {
  CleverTapEvent('cancel_application', payload);
};

// TaskReviewEvents
export const CleverTapTaskReviewApplicationAcceptEvent = payload => {
  const formatPayload = {
    ...payload,
    contractStartDate: convertStringToDate(payload?.contractStartDate),
    contractEndDate: convertStringToDate(payload?.contractEndDate),
  };
  CleverTapEvent(`click_application_accept`, formatPayload);
};
export const CleverTapTaskReviewApplicationAcceptSuccessEvent = payload => {
  const formatPayload = {
    ...payload,
    contractStartDate: convertStringToDate(payload?.contractStartDate),
    contractEndDate: convertStringToDate(payload?.contractEndDate),
  };
  CleverTapEvent(`application_accept_success`, formatPayload);
};
export const CleverTapTaskReviewApplicationAcceptFailureEvent = payload => {
  const formatPayload = {
    ...payload,
    contractStartDate: convertStringToDate(payload?.contractStartDate),
    contractEndDate: convertStringToDate(payload?.contractEndDate),
  };
  CleverTapEvent(`application_accept_failure`, formatPayload);
};

export const CleverTapTaskReviewApplicationRejectEvent = payload => {
  const formatPayload = {
    ...payload,
    contractStartDate: convertStringToDate(payload?.contractStartDate),
    contractEndDate: convertStringToDate(payload?.contractEndDate),
  };
  CleverTapEvent(`click_application_reject`, formatPayload);
};
export const CleverTapTaskReviewApplicationRejectSuccessEvent = payload => {
  const formatPayload = {
    ...payload,
    contractStartDate: convertStringToDate(payload?.contractStartDate),
    contractEndDate: convertStringToDate(payload?.contractEndDate),
  };
  CleverTapEvent(`application_reject_success`, formatPayload);
};
export const CleverTapTaskReviewApplicationRejectFailureEvent = payload => {
  const formatPayload = {
    ...payload,
    contractStartDate: convertStringToDate(payload?.contractStartDate),
    contractEndDate: convertStringToDate(payload?.contractEndDate),
  };
  CleverTapEvent(`application_reject_failure`, formatPayload);
};

export const CleverTapTaskReviewApplicationReturnEvent = payload => {
  const formatPayload = {
    ...payload,
    contractStartDate: convertStringToDate(payload?.contractStartDate),
    contractEndDate: convertStringToDate(payload?.contractEndDate),
  };
  CleverTapEvent(`click_application_return`, formatPayload);
};
export const CleverTapTaskReviewApplicationReturnSuccessEvent = payload => {
  const formatPayload = {
    ...payload,
    contractStartDate: convertStringToDate(payload?.contractStartDate),
    contractEndDate: convertStringToDate(payload?.contractEndDate),
  };
  CleverTapEvent(`application_return_success`, formatPayload);
};
export const CleverTapTaskReviewApplicationReturnFailureEvent = payload => {
  const formatPayload = {
    ...payload,
    contractStartDate: convertStringToDate(payload?.contractStartDate),
    contractEndDate: convertStringToDate(payload?.contractEndDate),
  };
  CleverTapEvent(`application_return_failure`, formatPayload);
};

export const CleverTapTaskReviewApplicationTerminateEvent = payload => {
  const formatPayload = {
    ...payload,
    contractStartDate: convertStringToDate(payload?.contractStartDate),
    contractEndDate: convertStringToDate(payload?.contractEndDate),
  };
  CleverTapEvent(`click_application_terminate`, formatPayload);
};
export const CleverTapTaskReviewApplicationTerminateSuccessEvent = payload => {
  const formatPayload = {
    ...payload,
    contractStartDate: convertStringToDate(payload?.contractStartDate),
    contractEndDate: convertStringToDate(payload?.contractEndDate),
  };
  CleverTapEvent(`application_terminate_success`, formatPayload);
};
export const CleverTapTaskReviewApplicationTerminateFailureEvent = payload => {
  const formatPayload = {
    ...payload,
    contractStartDate: convertStringToDate(payload?.contractStartDate),
    contractEndDate: convertStringToDate(payload?.contractEndDate),
  };
  CleverTapEvent(`application_terminate_failure`, formatPayload);
};

export const CleverTapTaskReviewApplicationEditEvent = payload => {
  const formatPayload = {
    ...payload,
    contractStartDate: convertStringToDate(payload?.contractStartDate),
    contractEndDate: convertStringToDate(payload?.contractEndDate),
  };
  CleverTapEvent(`click_application_edit`, formatPayload);
};

export const CleverTapTaskReviewScreenViewEvent = () => {
  CleverTapEvent('screen_view', {
    screenName: 'screen_task_details_view',
  });
};
export const CleverTapTaskReviewStatusViewEvent = payload => {
  CleverTapEvent('screen_view', {
    screenName: `screen_${payload?.applicationType}_${payload?.applicationStep}_status_view`,
  });
};

// Pma contracts
export const CleverTapPmaContractsFlow = () => {
  CleverTapEvent('pma_contracts');
};

// pma contract detail page
export const CleverTapPmaContractDetail = payload => {
  CleverTapEvent('pma_contract_detailpage', payload);
};

// pma contract detail page
export const CleverTapPOAWhoIsApplying = payload => {
  CleverTapEvent(`who_is_applying_next`, { whoIsApplying: payload.whoIsApplying });
};

// Fetch Owner Details
export const CleverTapFetchOwnerDetails = payload => {
  CleverTapEvent(`fetch_owner_details`, payload);
};

// Fetch Representative
export const CleverTapFetchRepresentative = payload => {
  CleverTapEvent(`fetch_representative`, payload);
};

// Fetch Poa Number
export const CleverTapFetchPoaNumber = payload => {
  const formatPayload = {
    ...payload,
    poaStartDate: convertStringToDate(payload?.poaStartDate),
    poaExpiryDate: convertStringToDate(payload?.poaExpiryDate),
  };
  CleverTapEvent(`fetch_poa_number`, formatPayload);
};

export const CleverTapAddNewMusataha = payload => {
  CleverTapEvent(`add_new_musateh`, payload);
};
export const CleverTapRemoveNewMusataha = payload => {
  CleverTapEvent(`remove_new_musateh`, payload);
};

// PMA
export const CleverTapPMASelectAgreementTypeEvent = payload => {
  CleverTapEvent('screen_view', payload);
};
export const CleverTapPMASelectPropertySelectionEvent = payload => {
  CleverTapEvent('click_select_property', payload);
};
export const CleverTapPMARemovePropertyEvent = payload => {
  CleverTapEvent('click_remove_property', payload);
};
export const CleverTapPMAFetchSecondPartyEvent = payload => {
  CleverTapEvent('click_fetch_second_party', payload);
};

// Lease Multi Units
export const CleverTapLeaseMultiUnitsSelectPropertyEvent = payload => {
  CleverTapEvent(`click_select_property`, {
    propertyIds: payload?.propertyIds,
    applicationType: payload?.applicationType,
  });
};

// Application & Tasks Filters
export const CleverTapApplicationsFiltersEvent = payload => {
  CleverTapEvent('applications_filters', payload);
};

export const CleverTapTasksFiltersEvent = payload => {
  CleverTapEvent('tasks_filters', payload);
};

export const CleverTapEtisalatScreenView = payload => {
  CleverTapEvent('screen_view', payload);
};

export const CleverTapConfirmEtisalatProduct = payload => {
  CleverTapEvent('confirm_etisalat_product', payload);
};

export const CleverTapCloseEtisalatBanner = payload => {
  CleverTapEvent('close_etisalat_banner', payload);
};
